import { render, staticRenderFns } from "./CreateTask.vue?vue&type=template&id=2d65d5d4&scoped=true&lang=pug"
import script from "./CreateTask.vue?vue&type=script&lang=js"
export * from "./CreateTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d65d5d4",
  null
  
)

export default component.exports